import { Component, OnInit } from '@angular/core';
import { ToastPosition } from './core/components/gt-toast/gt-toast.component';
import { GtOAuthService } from './core/services/gt-oauth.service';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  public position = ToastPosition.TOP_CENTER;

  constructor(private gtOauthService: GtOAuthService) {
    this.gtOauthService.oAuthConfiguration();
  }

  public ngOnInit() {
    this.gtOauthService.initiateOAuthFlow();
  }
}
